import _ from 'lodash';
import DashboardApi from '../../api/dashboard/dashboard-api-factory';
import NumberHelpers from '../../app/number-helpers';
import SummaryCard from '../reusable-elements/summary-card';
import { useContext, useState, useEffect, useMemo } from 'react';
import { IncomeAndExpenseContext } from './income-expense-container';
import { arrayAny } from '../../utils/arrayUtils';
import { useMsal } from '@azure/msal-react';

export const PaymentAllocationsTile = () => {

    const { instance, inProgress, accounts } = useMsal();
    const { chartSettings } = useContext(IncomeAndExpenseContext);
    
    const [shouldFetchData, setShouldFetchData] = useState(true);
    const [data, setData] = useState(null);
    const [fetchingData, setFetchingData] = useState(false);
    
    const income = data ?? { allocations: [] };

    const nh = new NumberHelpers();

    const dashboardApi = useMemo(() => new DashboardApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);

    useEffect(() => {
        async function fetchData() {
            if (shouldFetchData && !fetchingData) {
                setFetchingData(true);
                const data = await dashboardApi.getPeriodicPaymentAllocations();
                setData(data);
                setShouldFetchData(false);
                setFetchingData(false);
            }
        }
        fetchData();
    }, [dashboardApi, fetchingData, shouldFetchData]);

    const getCurrentStats = () => {
        if (!income || !arrayAny(income.allocations)) return { income: 0, pcChange: 0 };

        const current = _.minBy(income.allocations, r => r.order);
        const previous = income.allocations.find(r => r.order === current.order + 1);
        const pc = previous
            ? ((current.value - previous.value) / Math.abs(previous.value)) * 100
            : current.value > 0 ? 100 : current.value < 0 ? -100 : 0;
        return { income: current.value, pcChange: pc };
    };

    const headLineFigures = getCurrentStats();

    const averageIncome = () => {
        if (!income || !arrayAny(income.allocations)) return 0;

        const total = income.allocations.reduce((acc, r) => acc + r.value, 0);
        return total / income.allocations.length;
    };

    const ave = averageIncome();

    const maxIncome = () => {
        if (!income || !arrayAny(income.allocations)) return 0;

        const max = _.maxBy(income.allocations, r => r.value);
        return max.value;
    };

    const max = maxIncome();

    return (
        <SummaryCard
            loading={fetchingData}
            headerTitle="TOTAL MONTHLY PAYMENT ALLOCATIONS"
            summaryValue={nh.convertNumberWithCommas(headLineFigures.income, "£")}
            summaryValueMovement={headLineFigures.pcChange}
            summaryValueMovementSuffix="%"
            options={chartSettings.options}
            series={[{ data: _.orderBy(income.allocations, a => a.order, 'desc').flatMap(s => s.value) }]}
            averageValue1={nh.convertNumberWithCommas(ave, "£")}
            averageValue1Label="Avg. Payments Per Month"
            averageValue2={nh.convertNumberWithCommas(max, "£")}
            averageValue2Label="Max. Payments in range">
        </SummaryCard>
    );
};